import React from "react";
import { Modal } from "react-bootstrap";
import HotWorkCategoryThreeOptionsFormState from "../../../../types/forms/Permits/EnergyHarbourPermit/HotWorkCategoryThreeOptionsFormState";
import { Transformation } from "../../../../types/functions";
import Resources from "../../../../types/Resources";
import LabelCheckbox from "../../../Common/LabelCheckbox";

type HotWorkCategoryThreeOptionsModalProps = {
    formState: HotWorkCategoryThreeOptionsFormState;
    onChange: (fn: Transformation<HotWorkCategoryThreeOptionsFormState>) => void;
    resources: Resources;
    show: boolean;
    onHide: () => void;
    canManageContent: boolean;
};

function HotWorkCategoryThreeOptionsModal({ formState, onChange, resources, show, onHide, canManageContent }: HotWorkCategoryThreeOptionsModalProps) {
    function changeHandler(key: keyof HotWorkCategoryThreeOptionsFormState, value: any) {
        onChange((prevValue) => ({
            ...prevValue,
            [key]: { ...prevValue[key], value }
        }));
    }

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <h1 className="h5">{resources.get("HotWorkCategoryThree")}</h1>
            </Modal.Header>
            <Modal.Body>
                <ul className="list-unstyled">
                    <li className="m-2">
                        <LabelCheckbox
                            checked={formState.vacuumTruck.value}
                            id="hot-work-category-three-options__vacuum-truck"
                            label={resources.get("VacuumTruck")}
                            onChange={(checked) => changeHandler("vacuumTruck", checked)}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <LabelCheckbox
                            checked={formState.excavator.value}
                            id="hot-work-category-three-options__excavator"
                            label={resources.get("Excavator")}
                            onChange={(checked) => changeHandler("excavator", checked)}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <LabelCheckbox
                            checked={formState.craneTruck.value}
                            id="hot-work-category-three-options__crane-truck"
                            label={resources.get("CraneTruck")}
                            onChange={(checked) => changeHandler("craneTruck", checked)}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <LabelCheckbox
                            checked={formState.generator.value}
                            id="hot-work-category-three-options__generator"
                            label={resources.get("Generator")}
                            onChange={(checked) => changeHandler("generator", checked)}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <LabelCheckbox
                            checked={formState.boat.value}
                            id="hot-work-category-three-options__boat"
                            label={resources.get("Boat")}
                            onChange={(checked) => changeHandler("boat", checked)}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <LabelCheckbox
                            checked={formState.drone.value}
                            id="hot-work-category-three-options__drone"
                            label={resources.get("Drone")}
                            onChange={(checked) => changeHandler("drone", checked)}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <LabelCheckbox
                            checked={formState.openExClassifiedEquipment.value}
                            id="hot-work-category-three-options__open-ex-classified-equipment"
                            label={resources.get("OpenExClassifiedEquipment")}
                            onChange={(checked) => changeHandler("openExClassifiedEquipment", checked)}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <LabelCheckbox
                            checked={formState.multimeter.value}
                            id="hot-work-category-three-options__multimeter"
                            label={resources.get("Multimeter")}
                            onChange={(checked) => changeHandler("multimeter", checked)}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <LabelCheckbox
                            checked={formState.nonExCamera.value}
                            id="hot-work-category-three-options__non-ex-camera"
                            label={resources.get("NonExCamera")}
                            onChange={(checked) => changeHandler("nonExCamera", checked)}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2">
                        <LabelCheckbox
                            checked={formState.GPS.value}
                            id="hot-work-category-three-options__gps"
                            label={resources.get("HotWorkCategoryThreeGPS")}
                            onChange={(checked) => changeHandler("GPS", checked)}
                            readOnly={!canManageContent}
                        />
                    </li>
                    <li className="m-2 d-flex align-items-center m-2">
                        <label className="form-label me-1" htmlFor="hot-work-category-three-options__other">
                            {resources.get("Other")}
                        </label>
                        <input
                            type="text"
                            className={`form-control ${!canManageContent ? "read-only-input" : ""}`}
                            id="hot-work-category-three-options__other"
                            value={formState.other.value ?? ""}
                            onChange={(e) => changeHandler("other", e.target.value)}
                            readOnly={!canManageContent}
                        />
                    </li>
                </ul>
            </Modal.Body>
        </Modal>
    );
}

export default HotWorkCategoryThreeOptionsModal;
